export const SET_EXPORT_MAP_MODAL = 'SET_EXPORT_MAP_MODAL';

export const setExportMapModal = showModal => {
  return { type: SET_EXPORT_MAP_MODAL, payload: showModal };
};